import { render } from "./HalfColumn.vue?vue&type=template&id=8bbf8658"
const script = {}

import "./HalfColumn.vue?vue&type=style&index=0&id=8bbf8658&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__